import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import CommaPrice from "src/features/Utils/CommaPrice";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import QuantityButton from "src/features/QuantityButton";
import React from "react";
import Typography from "@material-ui/core/Typography";

import NoImage from "src/assets/no-image.jpg";

// import IconButton from '@material-ui/core/IconButton'
// import Icon from '@material-ui/core/Icon'

const ProductStatusCircle = ({ in_stock }) => {
  const color = in_stock ? "#00FF22" : "#FFDD00";
  return (
    <Box
      component="div"
      width="9px"
      height="9px"
      borderRadius="20px"
      mt={0.8}
      mr={1}
      bgcolor={color}
    />
  );
};

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: "#F6F6F6",
    borderRadius: 4,
    padding: "16px 13px 8px 13px",
    marginTop: theme.spacing(1),
    display: "flex",
  },
}));

function CartCard(props) {
  const classes = useStyles();

  return (
    <div className={classes.card}>
      <Box
        component="img"
        src={props.cover_img || NoImage}
        width="67px"
        height="67px"
        mr={2}
      />
      <Grid container>
        <Box id="detail" mr={1}>
          <Box fontWeight="bold" mb={0.5}>
            {props.search_name}
          </Box>
          <Box
            color="text.secondary"
            width={{ xs: "190px", sm: "300px" }}
            textOverflow="ellipsis"
            overflow="hidden"
            whiteSpace="nowrap"
            mb={1}
          >
            {props.line1}
          </Box>
          <Box mb={1}>{props.line2}</Box>
          <Box fontSize="14px" display="flex">
            <ProductStatusCircle
              in_stock={
                !!props.stock_quantity && props.stock_quantity >= props.amount
              }
            />
            {!!props.stock_quantity && props.stock_quantity >= props.amount
              ? `สินค้าพร้อมส่งจำนวน ${props.stock_quantity}`
              : "สินค้าพรีออเดอร์"}
          </Box>
        </Box>
        <Box mt={3} display={{ xs: "block", sm: "flex" }} ml="auto">
          <Box id="quantity" mr={2}>
            <QuantityButton value={props.amount} onChange={props.onUpdate} />
          </Box>
          <Box
            id="price"
            padding="8px 16px"
            width="140px"
            textAlign="right"
            mt={{ xs: 1, sm: 0 }}
          >
            <Typography color={props.is_promo ? "primary" : "initial"}>
              {CommaPrice(
                props.is_promo
                  ? props.promo_price * props.amount
                  : props.price * props.amount
              )}
            </Typography>
          </Box>
        </Box>
      </Grid>
    </div>
  );
}

CartCard.propTypes = {
  cover_img: PropTypes.string,
  search_name: PropTypes.string,
  line1: PropTypes.string,
  line2: PropTypes.string,
  price: PropTypes.number,
  stock_quantity: PropTypes.number,
  promo_price: PropTypes.number,
  is_promo: PropTypes.bool,
  amount: PropTypes.number,
  _id: PropTypes.string,
  type: PropTypes.oneOf(["medicine", "supply"]),
};

export default CartCard;
